module.exports = __webpack_public_path__ + "img/title.c01922f6.jpg";